<template>
    <div class="no-data-comp d-flex justify-center line-card animation-opacity">
        <h1 class="app-title">
            {{smsNotData}}
        </h1>
    </div>
</template>
<script>
export default {
    props: {
        smsNotData: String
    }
}
</script>
<style scoped>
    .no-data-comp{
        padding: 6px;
        border-radius: 5px;
    }
</style>